import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer } from 'redux-persist';
import storage from "redux-persist/lib/storage";
import thunk from 'redux-thunk';
import authStateSlice from "./features/authStateSlice";
import b2bDBStateSlice from "./features/b2bDBStateSlice";
import personalDBStateSlice from "./features/personalDBStateSlice";
const allreducers = combineReducers(
    {
    auth: authStateSlice,
    dashboard: personalDBStateSlice,
    dashboardb2b: b2bDBStateSlice,
    }
);

const persistConfig = {
    key: 'root',
    storage,
  };

const persistedReducer = persistReducer(persistConfig, allreducers);
export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk],
});

export default store;